import React from 'react';
import '../styles/Spinner.css';

const Spinner = () => {
    return (
        <div className="main-spinner-container">
            <div className="loadingio-spinner">
                <div className="ldio">
                    {Array.from({ length: 12 }).map((_, i) => (
                        <div key={i}></div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Spinner;
